import { render, staticRenderFns } from "./DetailGadai.vue?vue&type=template&id=35d25a17&"
import script from "./DetailGadai.vue?vue&type=script&lang=js&"
export * from "./DetailGadai.vue?vue&type=script&lang=js&"
import style0 from "./DetailGadai.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports